import React from "react";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// react-bootstrap components
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Pagination,
  Container,
  Row,
  Col,
  Collapse,
  Modal,
  Alert,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { gantiPassword, logout } from "../../stores";
import { useDispatch, useSelector } from "react-redux";
import audio from "../../assets/sound/notif.mp3";
import { baseUrl } from "../../stores";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { getScoringByLoan } from "stores/Pengajuan/function";
import io, { Socket } from "socket.io-client";
import { getUlanngNotif } from "stores/Pengajuan/function";

function AdminNavbar() {
  const auth = useSelector((state) => state.authReducer);
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const valDetail = pengajuan.detailPengajuan;

  // console.log(auth);
  const dispatch = useDispatch();
  const history = useHistory();
  const idUser = localStorage.getItem("ID");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [modalUbahPassword, setModalUbahPassword] = React.useState(false);
  const [modalProfile, setModalProfile] = React.useState(false);
  const [oldPass, setOldPass] = React.useState("");
  const [newPass, setNewPass] = React.useState("");
  const [confirmPass, setConfirmPass] = React.useState("");

  const [passwordMatch, setPasswordMatch] = React.useState(true);
  const [showNewPass, setShowNewPass] = React.useState(false);
  const [showConfirmPass, setShowConfirmPass] = React.useState(false);
  const [notifikasi, setNotifikasi] = React.useState(null);
  const [showAlert, setShowAlert] = React.useState(false);

  const handleNewPassChange = (e) => {
    setNewPass(e.target.value);
    setPasswordMatch(e.target.value === confirmPass);
  };

  const handleConfirmPassChange = (e) => {
    setConfirmPass(e.target.value);
    setPasswordMatch(e.target.value === newPass);
  };

  const toggleShowNewPass = () => {
    setShowNewPass(!showNewPass);
  };

  const toggleShowConfirmPass = () => {
    setShowConfirmPass(!showConfirmPass);
  };

  const submitUbahPassword = () => {
    gantiPassword(dispatch, {
      username: auth.nopeg,
      passwordLama: oldPass,
      passwordBaru: newPass,
      role: auth.role,
    });
  };

  const playNotificationSound = () => {
    new Audio(audio).play();
  };

  React.useEffect(() => {
    const socket = io(baseUrl);
    socket.on("connect", () => {
      console.log("connected to server");
    });
    socket.emit("joinRoom", idUser);
    socket.on("notifikasi", (notif) => {
      console.log(notif, "NOTIFFFFF1");
      playNotificationSound();
      // alert("New Notification: " + notif);
      setNotifikasi(notif);
      // getAllNotif(dispatch);
      getAllPengajuan(dispatch, {
        status: "",
        cari: "",
        page: 1,
        limit: 10,
        tujuanPenggunaan: "",
      });
      getScoringByLoan(dispatch, {
        baploan: localStorage.getItem.id_pinjaman,
      });
      console.log(">>>>>>>>>>>>>>>>>>", pengajuan.statusConvert);
      getUlanngNotif(dispatch, { status: !pengajuan.statusConvert });
      console.log(notif, "NOTIFFFFF2");
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
        // window.location.reload();
      }, 3000);
    });
    // getAllNotif(dispatch);
    return () => {
      socket.disconnect();
    };
  }, [pengajuan.statusConvert]);

  return (
    <>
      {/* <div
        style={{
          position: "absolute",
          zIndex: 100,
          marginTop: 40,
          right: 0,
          marginRight: 15,
          width: "50%",
        }}
      >
        <Alert
          // variant="warning"
          style={{ backgroundColor: "#FF2B4B", color: "#E5F6FA" }}
          onClose={() => {}}
          // style={{ padding: 0, paddingTop: 0.5 }}
          show={showAlert}
        >
          <div>
            <h4 style={{ marginTop: 0, marginBottom: 5 }}>
              <b style={{ marginLeft: 5 }}>Notifikasi</b>
            </h4>
          </div>
          <p>
            <b>{notifikasi}</b>
          </p>
        </Alert>
      </div> */}
      <div>
        {showAlert && (
          <div
            style={{
              position: "fixed",
              top: 20,
              right: 20,
              zIndex: 100,
              padding: "10px 20px",
              backgroundColor: "#FF2B4B",
              color: "#E5F6FA",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              animation: "fadeInOut 3s ease-in-out",
            }}
          >
            <h4 style={{ margin: 0, fontWeight: "bold" }}>Notifikasi</h4>
            <p style={{ margin: "5px 0 0" }}>{notifikasi}</p>
          </div>
        )}
        <style>{`
          @keyframes fadeInOut {
            0% { opacity: 0; transform: translateY(-20px); }
            10% { opacity: 1; transform: translateY(0); }
            90% { opacity: 1; transform: translateY(0); }
            100% { opacity: 0; transform: translateY(-20px); }
          }
        `}</style>
      </div>

      <Modal
        size="md"
        show={modalUbahPassword}
        onHide={() => {
          setModalUbahPassword(false);
          setOldPass("");
          setNewPass("");
          setConfirmPass("");
          setPasswordMatch(true);
          setShowNewPass(false);
          setShowConfirmPass(false);
        }}
        centered
        className="modal-modern"
      >
        <Modal.Header closeButton className="border-0 pb-0" />
        <Modal.Body className="px-4 pb-4">
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#b1d9fa",
                borderRadius: "20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 10px 20px rgba(83, 171, 160, 0.2)",
                marginBottom: "15px",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <i
                className="fas fa-key text-primary fa-2x"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h4 className="fw-800 text-dark uppercase mb-0">Ubah Password</h4>
            <p className="text-muted small">
              Pastikan password baru Anda kuat dan sulit ditebak.
            </p>
          </div>

          <Form>
            {/* Password Lama */}
            <Form.Group className="mb-3">
              <label className="text-muted small fw-bold uppercase ml-1">
                Password Lama
              </label>
              <Form.Control
                className="rounded-lg shadow-none border-light-blue"
                style={{ height: "48px" }}
                onChange={(e) => setOldPass(e.target.value)}
                placeholder="Masukkan Password Lama"
                type="password"
              />
            </Form.Group>

            {/* Password Baru */}
            <Form.Group className="mb-3">
              <label className="text-muted small fw-bold uppercase ml-1">
                Password Baru
              </label>
              <InputGroup
                className="rounded-lg border shadow-none overflow-hidden"
                style={{ height: "48px" }}
              >
                <Form.Control
                  className="border-0"
                  onChange={handleNewPassChange}
                  placeholder="Masukkan Password Baru"
                  type={showNewPass ? "text" : "password"}
                />
                <InputGroup.Append>
                  <Button
                    variant="link"
                    className="text-muted text-decoration-none px-3 border-0"
                    onClick={toggleShowNewPass}
                  >
                    <i
                      className={`fa ${showNewPass ? "fa-eye" : "fa-eye-slash"}`}
                    ></i>
                  </Button>
                </InputGroup.Append>
              </InputGroup>
            </Form.Group>

            {/* Konfirmasi Password */}
            <Form.Group className="mb-4">
              <label className="text-muted small fw-bold uppercase ml-1">
                Konfirmasi Password Baru
              </label>
              <InputGroup
                className="rounded-lg border shadow-none overflow-hidden"
                style={{
                  height: "48px",
                  borderColor: passwordMatch ? "" : "#E11D48",
                }}
              >
                <Form.Control
                  className="border-0"
                  onChange={handleConfirmPassChange}
                  placeholder="Konfirmasi Password Baru"
                  type={showConfirmPass ? "text" : "password"}
                />
                <InputGroup.Append>
                  <Button
                    variant="link"
                    className="text-muted text-decoration-none px-3 border-0"
                    onClick={toggleShowConfirmPass}
                  >
                    <i
                      className={`fa ${showConfirmPass ? "fa-eye" : "fa-eye-slash"}`}
                    ></i>
                  </Button>
                </InputGroup.Append>
              </InputGroup>
              {!passwordMatch && (
                <div className="text-danger small mt-2 ml-1 fw-600">
                  <i className="fas fa-exclamation-circle mr-1"></i>
                  Password konfirmasi tidak cocok.
                </div>
              )}
            </Form.Group>

            <Button
              className="btn-block py-3 fw-800 shadow-sm border-0"
              style={{
                backgroundColor: "#1D4ED8",
                borderRadius: "12px",
                letterSpacing: "1px",
              }}
              onClick={submitUbahPassword}
            >
              SIMPAN PERUBAHAN
            </Button>
          </Form>
        </Modal.Body>

        <style>{`
    .fw-800 { font-weight: 800; }
    .bg-light-blue { background-color: #E0F2FE; }
    .border-light-blue { border-color: #BAE6FD; }
    .rounded-lg { border-radius: 12px !important; }
    .input-group:focus-within { border-color: #1D4ED8 !important; box-shadow: 0 0 0 0.2rem rgba(29, 78, 216, 0.1) !important; }
  `}</style>
      </Modal>

      <Navbar expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize">
              <Button
                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                variant="dark"
                onClick={() => document.body.classList.toggle("sidebar-mini")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
              <Button
                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                variant="dark"
                onClick={() =>
                  document.documentElement.classList.toggle("nav-open")
                }
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
            </div>
            {/* <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}>
              Buttons
            </Navbar.Brand> */}
          </div>
          <button
            className="navbar-toggler navbar-toggler-right border-0"
            type="button"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button>
          <Navbar.Collapse className="justify-content-end" in={collapseOpen}>
            {/* <Nav className="nav mr-auto" navbar>
              <Form
                className="navbar-form navbar-left navbar-search-form ml-3 ml-lg-0"
                role="search"
              >
                <InputGroup>
                  <i className="nc-icon nc-zoom-split"></i>
                  <Form.Control
                    defaultValue=""
                    placeholder="Search..."
                    type="text"
                  ></Form.Control>
                </InputGroup>
              </Form>
            </Nav> */}
            <Nav navbar>
              {/* <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-414718872"
                  variant="default"
                >
                  <i className="nc-icon nc-bell-55 mr-1"></i>
                  <span className="notification">5</span>
                  <span className="d-lg-none">Notification</span>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 1
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 2
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 3
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 4
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Notification 5
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
            </Nav>
            {/* <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-165516306"
                variant="default"
                style={{ color: "black" }}
              >
                <img
                  alt="..."
                  src={require("assets/img/userNav.png").default}
                  height="20PX"
                  style={{ marginBottom: 5 }}
                ></img>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  href="#pablo"
                  onClick={() => setModalProfile(!modalProfile)}
                >
                  <i class="fas fa-user-edit" style={{ marginRight: 10 }}></i>
                  My Profile
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown> */}
            <Dropdown as={Nav.Item}>
              <Dropdown.Toggle
                as={Nav.Link}
                id="dropdown-41471887333"
                variant="default"
                style={{ color: "black" }}
              >
                <img
                  alt="..."
                  src={require("assets/img/menu.png").default}
                  height="25PX"
                  style={{ marginBottom: 5 }}
                ></img>
              </Dropdown.Toggle>
              {/* <Dropdown.Menu
                alignRight
                aria-labelledby="navbarDropdownMenuLink"
              >
                <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-email-85"></i>
                    Messages
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-umbrella-13"></i>
                    Help Center
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-settings-90"></i>
                    Settings
                  </Dropdown.Item>
                  <div className="divider"></div>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-lock-circle-open"></i>
                    Lock Screen
                  </Dropdown.Item>
                <Dropdown.Item
                  className="text-danger"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                  }}
                >
                  <i className="nc-icon nc-button-power"></i>
                  Log Out
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-primary"
                  href="#pablo"
                  onClick={() => setModalUbahPassword(!modalUbahPassword)}
                  // onClick={(e) => {
                  //   e.preventDefault();
                  //   logout();
                  // }}
                >
                  <i class="fa fa-key" style={{ marginRight: 10 }}></i>
                  Ubah Password
                </Dropdown.Item>
              </Dropdown.Menu> */}

              <Dropdown.Menu
                alignRight
                aria-labelledby="navbarDropdownMenuLink"
              >
                {/* <Dropdown.Item
                  className="text-primary"
                  href="#pablo"
                  // onClick={() => setModalUbahPassword(!modalUbahPassword)}
                >
                  <i class="fas fa-user" style={{ marginRight: 10 }}></i>
                  My Profile
                </Dropdown.Item> */}
                <Dropdown.Item
                  className="text-primary"
                  href="#pablo"
                  onClick={() => setModalUbahPassword(!modalUbahPassword)}
                >
                  <i class="fa fa-key" style={{ marginRight: 10 }}></i>
                  Ubah Password
                </Dropdown.Item>
                <Dropdown.Item
                  className="text-danger"
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    logout();
                  }}
                >
                  <i className="nc-icon nc-button-power icon-bold"></i>
                  Log Out
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default AdminNavbar;
